import { GeoMeshData } from "../core/geoMeshData";
import { GeoPoint } from "../core/geoPoint";
import { GeoPolygon } from "../core/geoPolygon";
import { GeoPolygonList } from "../core/geoPolygonList";
import { ResourceLoader } from "../core/resourceLoader";
import { Continent } from "../model/continent";
import { Country } from "../model/country";
import { SubContinent } from "../model/subContinent";
import * as Proto from "./countryProto";

export class CountryLoader {
    static async loadContinents(resourcePath: string): Promise<Continent[]> {
        let bytes = await ResourceLoader.loadAsArrayBuffer(resourcePath);
        let proto = Proto.ContinentListProto.decode(new Uint8Array(bytes));
        return proto.continents.map(CountryLoader.protoToContinent);
    }

    private static protoToContinent(proto: Proto.ContinentProto$Properties): Continent {
        let continent = new Continent();
        continent.isoCode = proto.isoCode!;
        continent.subContinents = proto.subContinents!.map(it => CountryLoader.protoToSubContinent(it, continent));
        return continent;
    }

    private static protoToSubContinent(proto: Proto.SubContinentProto$Properties, parentContinent: Continent): SubContinent {
        let subContinent = new SubContinent();
        subContinent.parentContinent = parentContinent;
        subContinent.isoCode = proto.isoCode!;
        subContinent.countries = proto.countries!.map(it => CountryLoader.protoToCountry(it, subContinent));
        return subContinent;
    }

    private static protoToCountry(proto: Proto.CountryProto$Properties, parentSubContinennt: SubContinent): Country {
        let country = new Country();
        country.name = proto.name!;
        country.parentSubContinent = parentSubContinennt;
        country.isoCode = proto.isoCode!;
        country.domainExtension = proto.domainExtension!;
        country.capitalPosition = CountryLoader.protoToGeoPoint(proto.capitalPosition!);
        country.focusPosition = CountryLoader.protoToGeoPoint(proto.focusPosition!);
        country.cameraAltitude = proto.cameraAltitude!;
        country.cameraAltitude *= country.cameraAltitude; // push to square for better curve
        country.ldPolygons = CountryLoader.protoToGeoPolygonList(proto.hdPolygons!);
        country.hdPolygons = CountryLoader.protoToGeoPolygonList(proto.hdPolygons!);
        country.meshData = CountryLoader.protoToGeoMeshData(proto.meshData!);
        return country;
    }

    private static protoToGeoPoint(proto: Proto.GeoPointProto$Properties): GeoPoint {
        return new GeoPoint(proto.latitude!, proto.longitude!);
    }

    private static protoToGeoPolygon(proto: Proto.PolygonProto$Properties): GeoPolygon {
        return new GeoPolygon(proto.points!.map(CountryLoader.protoToGeoPoint));
    }

    private static protoToGeoPolygonList(proto: Proto.PolygonProto$Properties[]): GeoPolygonList {
        return new GeoPolygonList(proto.map(CountryLoader.protoToGeoPolygon));
    }

    private static protoToGeoMeshData(proto: Proto.MeshDataProto$Properties): GeoMeshData {
        let points = proto.vertices!.map(CountryLoader.protoToGeoPoint);
        let indices = proto.indices!;
        return new GeoMeshData(points, indices);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/dataAccess/countryLoader.ts